/**
 * Created by murzik on 10.10.16.
 */
import angular from 'angular';
export default angular.module('ui.flipper', [])

  .directive("flipper", function () {
    return {
      restrict: "E",
      template: "<div class='flipper' ng-transclude ng-class='{ flipped: flipped }'></div>",
      transclude: true,
      scope: {
        flipped: "="
      }
    };
  })

  .directive("front", function () {
    return {
      restrict: "E",
      template: "<div class='front tile' ng-transclude></div>",
      transclude: true
    };
  })

  .directive("back", function () {
    return {
      restrict: "E",
      template: "<div class='back tile' ng-transclude></div>",
      transclude: true
    }
  })
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/ui/flipper/index.js
 **/